import { z } from 'zod';
import { paginationMetaSchema } from '@/api/pagination';
import { PUBLISH_PANEL_PATH, PUBLISH_PANEL_PATHS } from '../constants/publish.constants';

export const candidateSchema = z.object({
  userId: z.coerce.number(),
  username: z.string().nullable(),
  fullName: z.string().nullable(),
  hrEmpId: z.string().nullable(),
  mobile: z.string().nullable(),
  departmentName: z.string().nullable(),
  designationName: z.string().nullable(),
  divisionName: z.string().nullable(),
  districtName: z.string().nullable(),
  thanaName: z.string().nullable(),
  dcrAmount: z.number(),
  derAmount: z.number(),
  totalAmount: z.number(),
  specimenCount: z.number(),
  dcrCount: z.number(),
  derCount: z.number(),
});

export const candidateListSchema = z.array(candidateSchema);

export const batchSchema = z.object({
  batchId: z.coerce.number(),
  legacyId: z.coerce.number(),
  name: z.string().nullable(),
  publishDate: z.string(),
  publishedBy: z.string().nullable(),
  trnDateFrom: z.string().nullable(),
  trnDateTo: z.string().nullable(),
  dcrAmount: z.number(),
  derAmount: z.number(),
  totalAmount: z.number(),
  specimenCount: z.number(),
  memberCount: z.number(),
  dcrCount: z.number(),
  derCount: z.number(),
  isConfirm: z.boolean().nullable(),
  confirmDate: z.string().nullable(),
  confirmedBy: z.string().nullable(),
  salesComment: z.string().nullable(),
  isDisburse: z.boolean(),
  disburseDate: z.string().nullable(),
  disbursedBy: z.string().nullable(),
  accountsComment: z.string().nullable(),
  publishComment: z.string().nullable(),
  stage: z.string(),
  rowsArchived: z.boolean(),
});

export const batchResponseSchema = z.object({
  data: z.array(batchSchema),
  meta: paginationMetaSchema,
});

export const batchMemberSchema = z.object({
  userId: z.coerce.number(),
  username: z.string().nullable(),
  fullName: z.string().nullable(),
  hrEmpId: z.string().nullable(),
  mobile: z.string().nullable(),
  designationName: z.string().nullable(),
  divisionName: z.string().nullable(),
  districtName: z.string().nullable(),
  thanaName: z.string().nullable(),
  dcrAmount: z.number(),
  derAmount: z.number(),
  totalAmount: z.number(),
  specimenCount: z.number(),
  dcrCount: z.number(),
  derCount: z.number(),
});

export const batchMemberListSchema = z.array(batchMemberSchema);

export const batchSearchSchema = z.object({
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  batchId: z.coerce.number().optional(),
  trnDateFrom: z.string().optional(),
  trnDateTo: z.string().optional(),
  userId: z.coerce.number().optional(),
});

export const batchMembersSearchSchema = z.object({
  from: z.enum(PUBLISH_PANEL_PATHS).catch(PUBLISH_PANEL_PATH.sales),
});

export const candidateSearchSchema = z.object({
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  userId: z.coerce.number().optional(),
});

export type Candidate = z.infer<typeof candidateSchema>;
export type Batch = z.infer<typeof batchSchema>;
export type BatchMember = z.infer<typeof batchMemberSchema>;
export type BatchResponse = z.infer<typeof batchResponseSchema>;
export type BatchSearch = z.infer<typeof batchSearchSchema>;
export type CandidateSearch = z.infer<typeof candidateSearchSchema>;
export type BatchMembersSearch = z.infer<typeof batchMembersSearchSchema>;

export interface PublishPayload {
  userIds: number[];
  dateFrom: string;
  dateTo: string;
  dcrAmount: number;
  derAmount: number;
  specimenCount: number;
  comments?: string;
}
